import { service } from 'services';
import { hotGetAction, basicCRUDAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export default {
  cluster: {
    create: async ({ properties }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.CREATE,
      apiResult: service.kubernetes.cluster.create({ properties }),
    }),

    update: async ({ id, properties }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.UPDATE,
      apiResult: service.kubernetes.cluster.update({ id, properties }),
    }),

    delete: async ({ id }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.DELETE,
      apiResult: service.kubernetes.cluster.delete({ id }),
    }),

    get: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.GET,
      apiResult: service.kubernetes.cluster.get({ id }),
      payloadKey: 'cluster',
    }),

    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.GET_ALL,
      apiResult: service.kubernetes.cluster.getAll(),
      payloadKey: 'clusters',
      isRetrieveItems: true,
    }),

    getKubeConfigFile: async ({ id }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.CLUSTER.GET_KUBE_CONFIG_FILE,
      apiResult: service.kubernetes.cluster.getKubeConfigFile({ id }),
      payloadKey: 'kubeConfigFile',
      retrieveByFunction: (kubeconfig) => kubeconfig,
    }),
  },

  nodepool: {
    create: async ({ clusterId, properties }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.NODEPOOL.CREATE,
      apiResult: service.kubernetes.nodepool.create({ clusterId, properties }),
    }),

    update: async ({
      clusterId, id, properties,
    }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.NODEPOOL.UPDATE,
      apiResult: service.kubernetes.nodepool.update({ clusterId, id, properties }),
    }),

    delete: async ({ clusterId, id }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.NODEPOOL.DELETE,
      apiResult: service.kubernetes.nodepool.delete({ clusterId, id }),
    }),

    get: async ({ clusterId, id }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.NODEPOOL.GET,
      apiResult: service.kubernetes.nodepool.get({ clusterId, id }),
      payloadKey: 'nodepool',
    }),


    getAll: async ({ clusterId }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.NODEPOOL.GET_ALL,
      apiResult: service.kubernetes.nodepool.getAll({ clusterId }),
      payloadKey: 'nodepools',
      isRetrieveItems: true,
    }),
  },

  node: {
    recreate: async ({
      clusterId, nodepoolId, id,
    }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.NODE.RECREATE,
      apiResult: service.kubernetes.node.recreate({ clusterId, nodepoolId, id }),
    }),

    delete: async ({
      clusterId, nodepoolId, id,
    }) => basicCRUDAction({
      action: ACTIONS_TYPES.KUBERNETES.NODE.DELETE,
      apiResult: service.kubernetes.node.delete({ clusterId, nodepoolId, id }),
    }),

    get: async ({
      clusterId, nodepoolId, id,
    }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.NODE.GET,
      apiResult: service.kubernetes.node.get({ clusterId, nodepoolId, id }),
      payloadKey: 'node',
    }),


    getAll: async ({ clusterId, nodepoolId }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.NODE.GET_ALL,
      apiResult: service.kubernetes.node.getAll({ clusterId, nodepoolId }),
      payloadKey: 'nodes',
      isRetrieveItems: true,
    }),
  },

  version: {
    getAll: async () => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.VERSION.GET_ALL,
      apiResult: service.kubernetes.version.getAll(),
      payloadKey: 'versions',
    }),

    getDefault: async () => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.VERSION.GET_DEFAULT,
      apiResult: service.kubernetes.version.getDefault(),
      payloadKey: 'default',
    }),

    getCompatibilities: async ({ clusterVersion }) => hotGetAction({
      action: ACTIONS_TYPES.KUBERNETES.VERSION.GET_COMPATIBILITIES,
      apiResult: service.kubernetes.version.getCompatibilities({ clusterVersion }),
      payloadKey: 'compatibilities',
    }),
  },
};
